export default __webpack_public_path__ + "static/media/vintage65g-3.44676bf3.jpg";